import styled from 'styled-components'

export const Wrapper = styled.div`
  max-width: 60rem;
`

Wrapper.displayName = 'Wrapper'

export const EmptyStateImage = styled.img`
  max-width: 12.125rem;
`

EmptyStateImage.displayName = 'EmptyStateImage'
